import { prop } from 'ramda';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSocketSelector } from 'js/store/hooks';
import { useGetClientIP } from 'server';

import * as actions from '../store/actions';

export const useClientIP = () => {
    const dispatch = useDispatch();
    const getClientIP = useGetClientIP();
    const connected = useSocketSelector(prop('connected'));

    useEffect(() => {
        if (!connected) {
            return;
        }

        (async () => {
            const { clientIp } = await getClientIP();

            dispatch(actions.setClientIP(clientIp));
        })();
    }, [
        dispatch,
        connected,
        getClientIP
    ]);
};
